// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectFormStepSlider_content__PPYOr","titleContent":"ProjectFormStepSlider_titleContent__0xOrH","title":"ProjectFormStepSlider_title__65x97"};